var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ci class=\"fa fa-close fa-2x close-modal\" ng-click=\"$ctrl.close({$value: {bypassReadings: false}})\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"text-center padding-tb-20\"\u003E\u003Ch3 class=\"light-pink\"\u003EAttention\u003C\u002Fh3\u003E\u003Cp\u003EPensez à nous transmettre votre relève de compteur.\u003C\u002Fp\u003E\u003Cp\u003ESans elle, votre contrat restera inactif.\u003C\u002Fp\u003E\u003Cbutton class=\"btn background-light-pink\" ng-click=\"$ctrl.close({$value: {bypassReadings: true}})\"\u003EJ’AI COMPRIS\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/states/subscription/modal/bypassReadingsAlert.jade
// module id = 1167
// module chunks = 1